<main>
  <div>
    <section>
      <h1>Font</h1>
      <h2>Font</h2>
      <h3>Font</h3>
      <h4>Font</h4>
      <h5>Font</h5>
      <h6>Font</h6>
      <p class="title-1">Font</p>
      <p class="title-2">Font</p>
    </section>

    <section class="button-section">
      <div class="button-row">
        <button class="button yellow">Button</button>
        <button class="button yellow">Button</button>
        <button class="button yellow disabled">Button</button>
      </div>

      <div class="button-row">
        <button class="button primary">Button</button>
        <button class="button primary">Button</button>
        <button class="button primary-light">Light</button>
        <button class="button primary disabled">Button</button>
        <button class="button link">Edit</button>
      </div>

      <div class="button-row">
        <button class="button white">Button</button>
        <button class="button white">Button</button>
        <button class="button white disabled">Button</button>
      </div>

      <div class="button-row">
        <button class="button secondary">
          <span class="material-symbols-outlined">chevron_left</span>
          <span class="button-text">Button</span>
        </button>
        <button class="button secondary">Button</button>
        <button class="button secondary disabled">Button</button>
      </div>

      <div class="button-row">
        <button class="button card-button">
          <span class="material-symbols-outlined">assignment</span>
          <span class="button-text">Button</span>
        </button>

        <button class="button card-button-link">
          <span class="button-text">Button</span>
        </button>

        <button class="button card-button-link yellow-border">
          <span class="material-symbols-outlined">assignment</span>
          <span class="button-text">Button</span>
        </button>
      </div>

      <div class="button-row">
        <button class="button icon-only">
          <mat-icon svgIcon="copy"></mat-icon>
        </button>
      </div>
    </section>
  </div>
</main>
